<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="任务名称">
                <el-input v-model="formInline.job_name" placeholder="任务名称"></el-input>
            </el-form-item>
            <el-form-item label="任务分组">
                <el-select v-model="formInline.job_group" clearable  placeholder="任务分组">
                    <el-option
                            v-for="item in jobGroups"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="getQuartzList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <el-table-column type="index" label="序号" width="40"></el-table-column>
            <el-table-column prop="jobName" label="任务名称"></el-table-column>
            <el-table-column prop="job_group_name" label="任务分组" ></el-table-column>
            <el-table-column prop="description" label="任务描述"></el-table-column>
            <el-table-column prop="cronExpression" label="时间表达式" width="150">
            <template slot-scope="scope">
                <el-input v-model="scope.row.cronExpression" >
                </el-input>
            </template>
            </el-table-column>
            <el-table-column prop="jobClassName" label="执行类"></el-table-column>
            <el-table-column prop="start_time" label="开始时间" sortable></el-table-column>
            <!--<el-table-column prop="end_time" label="结束时间" sortable></el-table-column>-->
            <el-table-column prop="prev_fire_time" label="上次时间" sortable></el-table-column>
            <el-table-column prop="next_fire_time" label="下次时间" sortable></el-table-column>
            <el-table-column prop="status_name" label="状态" width="80"></el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button type="primary" v-if="scope.row.triggerState!='PAUSED'" size="mini" @click="handlePause(scope.row)">暂停</el-button>
                    <el-button type="success " v-if="scope.row.triggerState=='PAUSED'" size="mini" @click="handleResume(scope.row)">恢复</el-button>
                    <el-button type="success " size="mini" @click="handleExecuteOneceJob(scope.row)">执行</el-button>
                    <el-button type="warning " size="mini" @click="modifyJobTime(scope.row)">修改</el-button>
                    <el-button type="warning " size="mini" @click="handleDel(scope.row)">删除</el-button>
                  </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="新增定时任务" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="任务名称" >
                    <el-input v-model="form.job_name" placeholder="任务名称 唯一标示"></el-input>
                </el-form-item>
                <el-form-item label="任务分组">
                    <el-select v-model="form.job_group" clearable  placeholder="任务分组">
                        <el-option
                                v-for="item in jobGroups"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务描述">
                    <el-input v-model="form.description" placeholder="描述  创建人+任务描述"></el-input>
                </el-form-item>
                <el-form-item label="任务表达式">
                    <el-input v-model="form.cronExpression" placeholder="0 */1 * * * ?"></el-input>
                </el-form-item>
                <el-form-item label="自定义执行类">
                    <el-input v-model="form.jobClass" placeholder="cc.lechun.mall.service.quartz.job.TestJob 类全路径"></el-input>
                </el-form-item>
                <el-form-item label="spring执行类">
                    <el-input v-model="form.springBean" placeholder="customerService.test spring bean name和方法名"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addQuartzJob(form)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getQuartzList,getQuartzJobGroupList,addQuartzJob,pauseJob,resumeJob,deleteJob,executeOneceJob,modifyJobTime} from '../../api/api'

    //定义组件
    export default{
        data(){
            return {
                getQuartzList:[],
                jobGroups: [],
                loading:true,
                dialogFormVisible:false,
                form:{
                    "job_name":"",
                    "job_group":"",
                    "description":"",
                    "cronExpression":"",
                    "jobClass":"",
                    "springBean":""
                },
                formInline:{
                    "job_name":"",
                    "job_group":"",
                    currentPage:1,
                    recordsTotal:0,
                    pageSize:30,
                }
            }
        },
        //挂载时候执行
        mounted(){
            //获取查询条件下拉列表
            getQuartzJobGroupList({}).then((res) => {
                this.jobGroups = res.data;
            })
            //初始化首页数据
            this.getList();
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                getQuartzList(this.formInline).then((res) => {
                    this.loading = false;
                    this.getQuartzList = res.data.list;
                    this.formInline.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            handlePause(row){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                pauseJob({job_name:row.jobName,job_group:row.jobGroup}).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleResume(row){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                resumeJob({job_name:row.jobName,job_group:row.jobGroup}).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            modifyJobTime(row){
                console.log(row);
                const loading = this.$loading(this.GCONFIG.loadingParam);
                modifyJobTime({job_name:row.jobName,job_group:row.jobGroup,cron:row.cronExpression}).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleExecuteOneceJob(row){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                executeOneceJob({job_name:row.jobName,job_group:row.jobGroup}).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDel(row){
                this.$confirm('删除定时任务, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteJob({job_name:row.jobName,job_group:row.jobGroup}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handleAdd(){
                this.dialogFormVisible = true;
            },
            addQuartzJob(form){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                addQuartzJob(form).then((res) => {
                    loading.close();
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList();
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/quartz/quartzList.vue